import { useSelector } from 'react-redux';
import { Modal, Input, Select } from 'antd';
import { useState, useEffect } from 'react';
import EntitiesBrowser from '../../components/EntitiesBrowser';
import Localization from '../../utils/localization';

const ScenarioCreationModal = (props) => {
    const entities   = useSelector((state) => state.entities.entities);
    const currencies = useSelector((state) => state.currency.currency); // matches your Currency page selector

    const [name, setName]                   = useState('New Scenario');
    const [checkedNodes, setCheckedNodes]   = useState([]);
    const [expandedBusinessCases, setExpandedBusinessCases] = useState([]);
    const [localCurrencyId, setLocalCurrencyId] = useState(null);

    // Reset state when modal opens
    useEffect(() => {
        if (props.open) {
            setName('New Scenario');
            setCheckedNodes([]);
            setLocalCurrencyId(null);
        }
    }, [props.open]);

    const handleCheck = (nodes) => {
        if (!nodes) return;
        setCheckedNodes(nodes.map((node) => (Number.isInteger(node) ? node : node.scenario_id)));
    };

    const currencyOptions = (currencies ?? []).map((c) => ({
        label: c.currency,
        value: c.currency_id,
    }));

    return (
        <Modal
            bodyStyle={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
            }}
            title={Localization.scenario.create}
            open={props.open}
            onOk={() => {
                
                let scenarioTemplateId = null;
                if (checkedNodes && checkedNodes.length > 0) {
                    scenarioTemplateId = checkedNodes[0];
                }
                props.onConfirm(name, scenarioTemplateId, localCurrencyId);
            }}
           
            confirmLoading={false}
            onCancel={props.onCancel}
            destroyOnClose
        >
            <Input
                style={{ maxWidth: '275px', alignSelf: 'center' }}
                placeholder={Localization.businessCase.newName}
                onChange={(e) => setName(e.target.value)}
                defaultValue={'New Scenario'}
            />

            <Select
                style={{ maxWidth: '275px', alignSelf: 'center' }}
                placeholder="Select local currency"
                options={currencyOptions}
                value={localCurrencyId}
                onChange={(val) => setLocalCurrencyId(val)}
                allowClear
            />

            {entities ? (
                <EntitiesBrowser
                    entityStructure={entities}
                    handleCheck={handleCheck}
                    expandedBusinessCases={expandedBusinessCases}
                    setExpandedBusinessCases={setExpandedBusinessCases}
                    editable={false}
                    checkedNodes={checkedNodes}
                    radioButtonMode={true}
                />
            ) : (
                'No scenarios found.'
            )}
        </Modal>
    );
};

export default ScenarioCreationModal;